// import { EmployeeList } from "components/Employee";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { EmployeeList } from "../../components/EmployeeList";
import { FC } from "react";
import { PayrollQPIPEarningList } from "../../components/PayrollQPIPEarningList/PayrollQPIPEarningList";

export interface IPayrollQPIPEarningsListPage {}

export const PayrollQPIPEarningsListPage: FC<IPayrollQPIPEarningsListPage> = (
  props: IPayrollQPIPEarningsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll QPIP Earning"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "", navigateTo: "/payroll-federal-earning/list" },
      ]}
      mainContents={<PayrollQPIPEarningList />}
    />
  );
};
